import React from 'react'
import useDSApplicationMode from '../hooks/useDSApplicationMode'

export default function DSRenderWithMode({ allowedModes, children }) {
  const appMode = useDSApplicationMode()
  const doRender = allowedModes.includes(appMode)

  return <>{doRender ? children : null}</>
}
